import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Shell from "./pages/Shell";
import Dashboard from "./pages/Dashboard";
import Cases from "./pages/Cases";
import Suppliers from "./pages/Suppliers";
import Stats from "./pages/Stats";
import Alerts from "./pages/Alerts";
import ImportPage from "./pages/Import";
import Calendar from "./pages/Calendar";
import AllPayments from "./pages/AllPayments";
import CustomerPortal from "./pages/CustomerPortal";
import BackupsPage from "./pages/Backups";
import CrudPage from "./pages/CrudPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-zinc-500">Yükleniyor…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/portal/:slug" element={<CustomerPortal />} />
      <Route element={<Protected><Shell /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cases" element={<Cases />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/payments-all" element={<AllPayments />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/agencies" element={
          <CrudPage
            title="Aracı Kurumlar"
            subtitle="Aracı Kurum Yönetimi"
            endpoint="agencies"
            testPrefix="agencies"
            fields={[
              { key: "name", label: "Ad" },
              { key: "contact", label: "Yetkili" },
              { key: "phone", label: "Telefon" },
              { key: "email", label: "Email" },
              { key: "address", label: "Adres (Randevu PDF için)" },
              { key: "google_maps", label: "Google Maps Linki" },
              { key: "notes", label: "Notlar" },
            ]}
          />
        } />
        <Route path="/countries" element={
          <CrudPage
            title="Ülkeler"
            subtitle="Ülke Yönetimi"
            endpoint="countries"
            testPrefix="countries"
            fields={[
              { key: "name", label: "Ülke" },
              { key: "code", label: "Kod" },
              { key: "region", label: "Bölge", type: "select", options: [
                { value: "Schengen", label: "Schengen" },
                { value: "UK", label: "İngiltere" },
                { value: "USA", label: "Amerika" },
                { value: "Kanada", label: "Kanada" },
                { value: "Diğer", label: "Diğer" },
              ] },
            ]}
          />
        } />
        <Route path="/banks" element={
          <CrudPage
            title="Banka Hesapları"
            subtitle="Ödeme Hesapları"
            endpoint="banks"
            testPrefix="banks"
            fields={[
              { key: "name", label: "Hesap Adı" },
              { key: "currency", label: "Para Birimi", type: "select", options: [
                { value: "TL", label: "TL" }, { value: "EUR", label: "EUR" }, { value: "USD", label: "USD" }
              ], default: "TL" },
              { key: "iban", label: "IBAN" },
            ]}
          />
        } />
        <Route path="/stats" element={<Stats />} />
        <Route path="/backups" element={<BackupsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
